import * as Types from 'src/state/gql/_types';
import { Action, AsyncAction, GraphQLSubscriptionResultsPayload } from 'src/state/_types';
import { handleGraphqQLErrorResponse, handleGraphqQLSubscriptionErrorResponse, } from 'src/state/gql/utils';
import { subscriptions } from 'src/state/gql/_operations';
import { mapArrayToStateObject } from 'src/utils/state';

export const createBooking: AsyncAction<Types.CreateBookingWithSeriesMutationVariables,Types.CreateBookingWithSeriesMutation['item']> = async ({state, effects}, payload) => {
    state.bookings.errors = [];
    try {
        let { item } = await effects.gql.mutations.CreateBookingWithSeries(payload);
        return item;
    } catch (e: any) {
        state.bookings.errors = handleGraphqQLErrorResponse(e);
        return null;
    }
}

export const syncGetAllItems: Action<Types.SyncGetAllBookingsSubscriptionVariables> = async ({state, actions, effects}, payload) => {
    let { orderBy } = state.bookings.meta;
    state.bookings.loading = true;
    effects.subscriptions.subscribe<Types.SyncGetAllBookingsSubscription, Types.SyncGetAllBookingsSubscriptionVariables>(
        'syncGetAllBookings', 
        subscriptions.SyncGetAllBookings, 
        { ...payload, order_by: orderBy }, 
        actions.bookings.onAllItemsData,
        () => { state.bookings.loading = false }
    );
}

export const subscribeToAllItems: Action<Types.SyncGetBookingsSubscriptionVariables> = async ({actions}, payload) => {
    actions.bookings.syncGetAllItems(payload);
    actions.bookings.syncGetItemsMeta(payload);
}

export const onAllItemsData: Action<GraphQLSubscriptionResultsPayload<Types.SyncGetBookingsSubscription>> = async ({state}, payload) => {
    if (payload.error) {
        state.bookings.errors = [ ...state.bookings.errors, ...handleGraphqQLSubscriptionErrorResponse(payload.error) ];
    }
    if (payload.data&&payload.data.items) {
        state.bookings.items = mapArrayToStateObject(payload.data.items, 'id');
    }  
}

export const unsubscribeFromAllItems: Action = ({actions}) => {
    actions.bookings.unsubAllItemsData();
    actions.bookings.unsubItemsMeta();
}

export const unsubAllItemsData: Action = ({state,effects}) => {
    effects.subscriptions.unsubscribe('syncGetAllBookings');
    state.bookings.items = {};
}